import { useCallback, useState } from "react";

/**
 * @returns A function that forces a re-render of the current component when called.
 * Use e.g. to re-render a component when an external even occurs.
 */
export function useForceRender(): () => void {
  const [, setVersion] = useState(0);
  return useCallback(() => setVersion((v) => v + 1), []);
}
